export interface ErrorState {
  message?: string;
  status?: number;
  error?: string;
}

export enum ErrorActionTypes {
  UPDATE_ERROR = '@@error/UPDATE_ERROR',
}

export interface UpdateErrorAction {
  type: ErrorActionTypes.UPDATE_ERROR;
  payload: ErrorState;
}
